import script from "./SubmitPinglunhuikui.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitPinglunhuikui.vue?vue&type=script&setup=true&lang=js"

import "./SubmitPinglunhuikui.vue?vue&type=style&index=0&id=4380257f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4380257f"]])

export default __exports__